import createCache from 'services/createCache';

export default createCache({
	map: null,
	directions: null,
});
